var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("签到档位奖励设置")]),
      _c(
        "el-table",
        {
          staticClass: "tier-table sign-in-tier-table",
          attrs: { data: _setup.props.tiers, border: "", size: "mini" },
        },
        [
          _c("el-table-column", {
            attrs: { label: "日期", width: "90", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("第" + _vm._s(scope.row.day_index) + "天")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励类型", "min-width": "420" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "tier-reward-cell" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "140px" },
                            attrs: {
                              placeholder: "选择奖励类型",
                              size: "mini",
                            },
                            on: {
                              change: function ($event) {
                                return _setup.onRewardTypeChange(scope.$index)
                              },
                            },
                            model: {
                              value: scope.row.reward_type,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "reward_type", $$v)
                              },
                              expression: "scope.row.reward_type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: "无奖励",
                                value: _setup.SIGN_IN_REWARD_TYPE_NONE,
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: "金币",
                                value: _setup.SIGN_IN_REWARD_TYPE_COIN,
                              },
                            }),
                          ],
                          1
                        ),
                        scope.row.reward_type ===
                        _setup.SIGN_IN_REWARD_TYPE_COIN
                          ? [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "130px" },
                                  attrs: {
                                    placeholder: "奖励方式",
                                    size: "mini",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _setup.onRewardModeChange(
                                        scope.$index
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.reward_mode,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "reward_mode", $$v)
                                    },
                                    expression: "scope.row.reward_mode",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "固定奖励",
                                      value: _setup.REWARD_MODE_FIXED,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "随机奖励",
                                      value: _setup.REWARD_MODE_RANDOM,
                                    },
                                  }),
                                ],
                                1
                              ),
                              scope.row.reward_mode === _setup.REWARD_MODE_FIXED
                                ? [
                                    _c("span", {
                                      staticClass: "currency-prefix",
                                    }),
                                    _c("el-input-number", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        min: 0,
                                        precision: 2,
                                        controls: false,
                                        size: "mini",
                                      },
                                      model: {
                                        value: scope.row.gold,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "gold", $$v)
                                        },
                                        expression: "scope.row.gold",
                                      },
                                    }),
                                  ]
                                : [
                                    _c("span", {
                                      staticClass: "currency-prefix",
                                    }),
                                    _c("el-input-number", {
                                      staticStyle: { width: "90px" },
                                      attrs: {
                                        min: 0,
                                        precision: 2,
                                        controls: false,
                                        size: "mini",
                                      },
                                      model: {
                                        value: scope.row.gold_min,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "gold_min", $$v)
                                        },
                                        expression: "scope.row.gold_min",
                                      },
                                    }),
                                    _c("span", { staticClass: "rule-suffix" }, [
                                      _vm._v("~"),
                                    ]),
                                    _c("el-input-number", {
                                      staticStyle: { width: "90px" },
                                      attrs: {
                                        min: 0,
                                        precision: 2,
                                        controls: false,
                                        size: "mini",
                                      },
                                      model: {
                                        value: scope.row.gold_max,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "gold_max", $$v)
                                        },
                                        expression: "scope.row.gold_max",
                                      },
                                    }),
                                  ],
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励稽核倍数", width: "140", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        min: 0,
                        precision: 2,
                        controls: false,
                        size: "mini",
                        disabled:
                          scope.row.reward_type !==
                          _setup.SIGN_IN_REWARD_TYPE_COIN,
                      },
                      model: {
                        value: scope.row.multiple,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "multiple", $$v)
                        },
                        expression: "scope.row.multiple",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "已发放（份数）", width: "170", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        min: 0,
                        precision: 0,
                        controls: false,
                        size: "mini",
                        disabled: "",
                      },
                      model: {
                        value: scope.row.settled_count,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "settled_count", $$v)
                        },
                        expression: "scope.row.settled_count",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }